module.exports = __webpack_public_path__ + "0e054f71fcfe738b134cf2adda880df3.png";